<template>
  <div class="asc-analytic-grid-wrapper--container">
    <asc-analytic-grid
      :values="values"
      :on-open="onOpen"
      :grid-columns="gridColumns"
      :grid-filters="gridFilters"
    ></asc-analytic-grid>
  </div>
</template>

<script>
import { AscGridPropsMixin, AscRangeDatePickerMixin } from '@/components/mixins'
import AscAnalyticGrid from '@/components/molecules/AscAnalyticGrid'

export default {
  name: 'AscAnalyticGridWrapper',

  components: {
    AscAnalyticGrid,
  },

  mixins: [AscGridPropsMixin, AscRangeDatePickerMixin],

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: 'Admin - Analytic Management',
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      selectedAnalytic: [],
    }
  },
}
</script>
